export default "__VITE_ASSET__Mb3NlOkf__"